import { Dropdown, MenuProps } from 'antd';
import { useState } from 'react';
import ConfirmationModal from '../ConfirmationModal';
import { logout, removeTokenFromLocal, removeUserFromLocal } from 'app/modules/Auth/services';
import toast from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';
import { useMsal } from '@azure/msal-react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { LOGIN } from 'configs/routeNames';

const MenuDropdown = ({
  children,
  className = '',
}: {
  children: React.ReactNode;
  className?: string;
}) => {
  const [openLogoutModal, setOpenLogoutModal] = useState(false);
  const navigate = useNavigate();
  const { instance } = useMsal();
  const queryClient = useQueryClient();

  const logoutMutation = useMutation({
    mutationFn: logout,
    onSettled: () => {
      removeTokenFromLocal();
      removeUserFromLocal();
      queryClient.invalidateQueries({ queryKey: ['auth'] });
      navigate(`/${LOGIN}`);
      instance.logoutPopup().catch(() => {
        // MSAL popup logout failing is non-fatal - local session is already cleared.
      });
    },
    onError: () => {
      toast.error('Something went wrong while logging out');
    },
  });

  const showLogoutModal = () => setOpenLogoutModal(true);
  const handleConfirm = () => {
    setOpenLogoutModal(false);
    logoutMutation.mutate();
  };
  const handleCancel = () => setOpenLogoutModal(false);

  const items: MenuProps['items'] = [
    {
      key: 'logout',
      label: 'Logout',
      onClick: showLogoutModal,
    },
  ];

  return (
    <>
      <Dropdown menu={{ items }} className={className} overlayStyle={{ zIndex: 9999 }}>
        {children}
      </Dropdown>
      <ConfirmationModal
        isVisible={openLogoutModal}
        onConfirm={handleConfirm}
        onCancel={handleCancel}
        title="Confirm Logout"
        description="Are you sure you want to logout?"
      />
    </>
  );
};

export default MenuDropdown;
